import { Dispatch, FC } from 'react';
import cn from 'classnames';
import { VideoRecordType } from '@distribute/shared/api-types/video-record';

import { getMuxImage } from '@distribute/shared/utils';
import { Button, Icon } from '../../../../../shared/ui';

import {
  RecordCardDescription,
  RecordCardDuration,
  RecordCardPoster,
  styles,
} from '../../../../../features/recordings';
import { IconMap } from '../../../../../shared/sprite';

import { RecordCategory } from '../../../../../entities/recordings';

type Props = {
  record: VideoRecordType;
  category: RecordCategory;
  setRecordingPreview: Dispatch<React.SetStateAction<VideoRecordType | null>>;
  onInsert: (record: VideoRecordType) => void;
};

export const RecordCard: FC<Props> = ({
  record,
  category,
  setRecordingPreview,
  onInsert,
}) => {
  const { metadata, playbackId } = record;

  return (
    <div
      className={cn(styles.base, 'group cursor-pointer hover:shadow-md', {
        'h-64': category === RecordCategory.MY,
        'h-70': category === RecordCategory.SHARED,
      })}
      tabIndex={0}
    >
      <div
        className={cn(
          styles.poster,
          'border border-base-black/[0.08] relative'
        )}
      >
        <RecordCardDuration duration={(metadata?.mux?.duration || 0) * 1000} />
        <RecordCardPoster
          posterUrl={getMuxImage(playbackId || '')}
          className="group-hover:blur"
        />

        <div className="absolute top-0 left-0 z-10 flex flex-col items-center justify-center w-full h-full gap-2 transition-all duration-100 ease-linear opacity-0 group-hover:opacity-100">
          <Button
            variant="text"
            color="primary"
            className="w-45 !h-11 text-md"
            onClick={() => onInsert(record)}
          >
            Insert
          </Button>
          <Button
            variant="text"
            color="secondary"
            className="w-45 !h-9 text-sm"
            onClick={() => {
              setRecordingPreview(record);
            }}
          >
            <Icon glyph={IconMap.Eye} width={20} className="mr-1.5" />
            Preview
          </Button>
        </div>
      </div>
      <RecordCardDescription category={category} record={record} />
    </div>
  );
};
